<div class="background-container">
<h2 style="text-align: center;background-color: yellow;font-weight: bold;">3 BHK INTERIOR DESIGN PACKAGES</h2>
</div>
